
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React from "react";

import { getNewsApi } from "@libs/apis/news";

import News from "@components/pages/news";

const NewsPage = ({ listNews }) => {
  return (
    <div>
      <News dataNews={listNews} />
    </div>
  );
};

 async function _getServerSideProps() {
  const getListNews = await getNewsApi({
    populate: "image.file, newsCategory",
    limit: 10,
  });

  return {
    props: {
      listNews: getListNews?.data?.data || {},
    },
  };
}

export default NewsPage;


    export async function getServerSideProps(ctx) {
        let res = _getServerSideProps(ctx)
        if(typeof res.then === 'function') res = await res
        return {
          
          ...res,
          props: {
            ...(res.props || {}),
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/news/index',
              loaderName: 'getServerSideProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  